var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPyth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_339)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.515,
    y: 8.32983,
    width: 49.7,
    height: 49.7,
    rx: 24.85,
    fill: "#E6DAFE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7151 53.1299C46.5399 53.1299 55.3151 44.3547 55.3151 33.5299C55.3151 22.7052 46.5399 13.9299 35.7151 13.9299C24.8903 13.9299 16.1151 22.7052 16.1151 33.5299C16.1151 44.3547 24.8903 53.1299 35.7151 53.1299Z",
    fill: "#E6DAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3439 31.4245C39.3439 33.0094 38.0653 34.2956 36.4804 34.2956V37.1667C39.6424 37.1667 42.1996 34.6019 42.1996 31.4322C42.1996 28.2625 39.6348 25.6976 36.4804 25.6976C35.4392 25.6976 34.4592 25.9733 33.617 26.4633C31.9096 27.4509 30.7535 29.3114 30.7535 31.4322V45.7723L33.326 48.3525L33.617 48.6434V31.4245C33.617 29.8397 34.8956 28.5534 36.4804 28.5534C38.0653 28.5534 39.3439 29.8473 39.3439 31.4245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4808 19.9554C34.3983 19.9554 32.4459 20.5144 30.7615 21.4944C29.682 22.1145 28.7173 22.9108 27.8981 23.8448C26.1219 25.8661 25.0347 28.5228 25.0347 31.4322V40.0378L27.8981 42.9089V31.4245C27.8981 28.875 29.0006 26.5858 30.7615 25.0086C31.5884 24.2659 32.5531 23.684 33.625 23.3089C34.5208 22.9873 35.4854 22.8189 36.4884 22.8189C41.2276 22.8189 45.0711 26.67 45.0711 31.4245C45.0711 36.179 41.22 40.0301 36.4808 40.0301V42.9012C42.7972 42.9012 47.9192 37.7639 47.9192 31.4322C47.9192 25.1004 42.7972 19.9554 36.4808 19.9554Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_339",
    x: 0.0150146,
    y: 0.629834,
    width: 70.7,
    height: 70.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_339"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_339",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_339"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.1151,
    y: 13.9299,
    width: 39.2,
    height: 39.2,
    rx: 19.6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyth);
export default __webpack_public_path__ + "static/media/pyth.f0351a2afcc3d217de231acfac318987.svg";
export { ForwardRef as ReactComponent };